import {
    READ_NOTIFICATION,
    INSTANT_NOTIFICATION,
    OPEN_NOTIFICATIONS_WINDOW,
    CLOSE_NOTIFICATIONS_WINDOW,
    PRIVATE_TOKEN_NOTIFICATION,
    GET_MEMBER_NOTIFICATIONS_LIST
} from '../constants/notifications';

export const receiveNotification = data => ({
    type: INSTANT_NOTIFICATION,
    data
});

export const readNotification = data => ({
    type: READ_NOTIFICATION,
    data
});

export const privateTokenNotification = data => ({
    type: PRIVATE_TOKEN_NOTIFICATION,
    data
});

export const getMemberNotificationsList = data => ({
    type: GET_MEMBER_NOTIFICATIONS_LIST,
    data
});

export const openNotificationsWindow = () => ({ type: OPEN_NOTIFICATIONS_WINDOW });

export const closeNotificationsWindow = () => ({ type: CLOSE_NOTIFICATIONS_WINDOW });



// WEBPACK FOOTER //
// ./src/actions/notifications.js